<app-modal-shell (dismiss)="modalController.dismiss()" [dismissLabel]="'general.close' | translate">
  <h2 modalTitle>{{ 'employeeV2.welcome.' + document | translate }}</h2>
  @if (document === 'privacy') { <app-privacy /> }
  @else { <div [innerHTML]="'terms.termsOfUse' | translate"></div> }
</app-modal-shell>
